export enum ScreenTriggerCellBlock {
  Root = 'ScreensTriggerCell',
}
